import http from '@/includes/http'
import type { AxiosRequestConfig } from 'axios'

export const HttpGet = async (url: string, config?: AxiosRequestConfig): Promise<CustomAxiosResponse> => {
  if (config?.params?.include && Array.isArray(config?.params?.include)) {
    config.params.include = config.params.include.join(',')
  }

  return await http.get(url, config)
}

export const HttpPost = async (url: string, data?: any, config?: AxiosRequestConfig): Promise<CustomAxiosResponse> => {
  return await http.post(url, data, config)
}

export const HttpPut = async (url: string, data?: any, config?: AxiosRequestConfig): Promise<CustomAxiosResponse> => {
  return await http.put(url, data, config)
}

export const HttpPatch = async (url: string, data?: any, config?: AxiosRequestConfig): Promise<CustomAxiosResponse> => {
  return await http.patch(url, data, config)
}

export const HttpDelete = async (url: string, config?: AxiosRequestConfig): Promise<CustomAxiosResponse> => {
  return await http.delete(url, config)
}
